import {connect} from "react-redux";

import {postMessageToParent} from "../lookMessaging";
import {GROHE_ON_OPEN_ACTION, GROHE_POST_MESSAGES_ACTIONS} from "../iframeIntegration";
import {getCurrentLayout} from "../../appLayout";
import {getTempIdForPostMessage, LIXIL_USER_QUERY_PARAMS} from "../../../api/look-api";
import {getLookId} from "../lookNavigation/lookFunctions2";
import {loaderEnable} from "../../ui/loaderView";

const WithLoginPostMessage = (props) => {

  const {children, lookReturnAction, activePreset, bvPresets, exisingTempId} = props;

  const loginPostMessage = async (sessionEnded = false) => {
    loaderEnable();
    const layout = getCurrentLayout();
    await layout.updateLocalStorage();

    let tempId = await getTempIdForPostMessage(lookReturnAction || GROHE_ON_OPEN_ACTION.saveQuote, exisingTempId);
    let lookUrl = window.location.href;

    if (sessionEnded) {
      const searchParams = new URLSearchParams(
        (window.location.search).replace(/amp;/g, "")
        || (window.location.hash).replace(/(.*)\?/g, "")
        || ""
      );
      LIXIL_USER_QUERY_PARAMS.forEach(param => searchParams.delete(param));

      let stringifiedParams = searchParams.toString();
      let baseHref = window.location.origin + window.location.pathname;
      if (baseHref[baseHref.length - 1] === "/") {
        baseHref.slice(0, -1);
      }
      if (stringifiedParams && stringifiedParams.length && stringifiedParams[0] !== "?") {
        stringifiedParams = "?" + stringifiedParams;
      }
      lookUrl = baseHref + stringifiedParams + window.location.hash;

    }

    if (!lookUrl.includes("look-")) {
      const withHashUrl = new URL(lookUrl);
      const lookId = getLookId(activePreset, bvPresets);
      withHashUrl.hash = `#/look-${lookId}`;
      lookUrl = withHashUrl.href;
    }

    console.log("returnUrl: ", lookUrl);

    postMessageToParent({
      "EventType": GROHE_POST_MESSAGES_ACTIONS.signIn,
      "returnUrl": lookUrl,
      "tempID": tempId
    });
  }

  return children(loginPostMessage)
};

const mapStateToProps = (store) => {
  const {lookReturnAction} = store.lookState;
  const {exisingTempId} = store.groheState;
  const {activePreset, bvPresets} = store.bathroomVisualizerState;

  return {
    lookReturnAction,
    activePreset,
    bvPresets,
    exisingTempId,
  }
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WithLoginPostMessage)
